var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.to}},[_c('span',{staticClass:"link-component-text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }